/* ============================================================
   skinmade — Native Slide-Cart (ersetzt AMP Slide-Cart-App)
   ------------------------------------------------------------
   Baut auf den nativen Theme-Cart-Drawer auf und ergänzt:
   1. Reservierungs-Countdown (kosmetisch, 10 Min, Reset bei Aktivität)
   2. 2-stufige Reward-Bar: 50€ Kostenloser Versand · 150€ Gratis Sample-Set
   3. Sample-Set-Auto-Add/Remove bei 150€ (Bxgy-Rabatt macht es 0€)
   4. SLIDECART_*-Shim → mappt auf theme:open/close/cartchanged,
      damit frontend-shop.js / sm-login.js / SumUp weiterlaufen.
   Der Theme-Drawer rendert neu via CustomEvent('theme:cartchanged').
   ============================================================ */
(function () {
  'use strict';

  var CFG = {
    SAMPLE_VARIANT_ID: 46159279096075, // Produkt "sample set" /sample-set
    TIER1: 5000,   // 50,00 € → Kostenloser Versand
    TIER2: 15000,  // 150,00 € → Kostenloses Sample-Set
    TIMER_SECONDS: 600 // 10:00 Reservierung
  };

  var IS_EN = (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('en') === 0
    || /^\/en(\/|$)/.test(location.pathname);

  var T = IS_EN ? {
    reserved: function (mmss) { return 'We’ve reserved your cart for <strong>' + mmss + '</strong>.'; },
    ship_free: 'Free shipping',
    sample_free: 'Free sample set',
    to_ship: function (amt) { return 'Only <span class="sm-sc-amt">' + amt + '</span> away from <strong>free shipping</strong>.'; },
    to_sample: function (amt) { return 'Free shipping unlocked — only <span class="sm-sc-amt">' + amt + '</span> to a <strong>free sample set</strong>.'; },
    all_done: 'Free shipping <strong>and</strong> a free sample set — enjoy!',
    disc_ph: 'Discount code', disc_apply: 'Apply',
    disc_ok: 'Discount applied.', disc_err: 'Code invalid or not applicable.',
    sub_once: 'One-time', sub_abo: 'Subscribe -20%', sub_every: 'every', sub_weeks: 'weeks',
    sub_off: '-20%', sub_hint_once: 'Subscribe & save', sub_hint_on: 'You save'
  } : {
    reserved: function (mmss) { return 'Wir haben deinen Warenkorb für <strong>' + mmss + '</strong> reserviert.'; },
    ship_free: 'Kostenloser Versand',
    sample_free: 'Gratis Sample-Set',
    to_ship: function (amt) { return 'Noch <span class="sm-sc-amt">' + amt + '</span> bis zum <strong>kostenlosen Versand</strong>.'; },
    to_sample: function (amt) { return 'Kostenloser Versand erreicht — noch <span class="sm-sc-amt">' + amt + '</span> bis zum <strong>gratis Sample-Set</strong>.'; },
    all_done: 'Kostenloser Versand <strong>und</strong> gratis Sample-Set — stark!',
    disc_ph: 'Rabattcode', disc_apply: 'Anwenden',
    disc_ok: 'Rabatt angewendet.', disc_err: 'Code ungültig oder nicht anwendbar.',
    sub_once: 'Einmalig', sub_abo: 'Abo -20%', sub_every: 'alle', sub_weeks: 'Wochen',
    sub_off: '-20%', sub_hint_once: 'Im Abo sparst du', sub_hint_on: 'Du sparst'
  };

  var SVG_CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
  var SVG_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="#34312E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4h13v11H1z"/><path d="M14 8h4l3 3v4h-7z"/><circle cx="5.5" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/></svg>';
  var SVG_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="#34312E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  var SVG_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  function money(cents) {
    var v = (cents / 100).toLocaleString(IS_EN ? 'en-IE' : 'de-DE', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
    return '€' + v;
  }

  // ---- Timer state (kosmetisch, Reset bei Aktivität) --------
  var timerInt = null, timerLeft = CFG.TIMER_SECONDS;
  function fmtTime(s) {
    var m = Math.floor(s / 60), ss = s % 60;
    return m + ':' + (ss < 10 ? '0' : '') + ss;
  }
  function paintTimer() {
    var el = document.querySelector('.sm-sc-timer');
    if (!el) return;
    el.innerHTML = SVG_CLOCK + '<span>' + T.reserved(fmtTime(timerLeft)) + '</span>';
    el.classList.toggle('is-expired', timerLeft <= 0);
  }
  function tickTimer() {
    if (timerLeft > 0) { timerLeft -= 1; paintTimer(); }
    else { clearInterval(timerInt); timerInt = null; }
  }
  function resetTimer() {
    timerLeft = CFG.TIMER_SECONDS;
    paintTimer();
    if (!timerInt) timerInt = setInterval(tickTimer, 1000);
  }

  // ---- Cart-Helfer ------------------------------------------
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function qualifyingTotal(cart) {
    // Summe aller ECHTEN Positionen (ohne das Gratis-Sample-Set)
    var sum = 0;
    (cart.items || []).forEach(function (it) {
      if (it.variant_id === CFG.SAMPLE_VARIANT_ID) return;
      sum += it.final_line_price;
    });
    return sum;
  }
  function sampleLine(cart) {
    return (cart.items || []).filter(function (it) { return it.variant_id === CFG.SAMPLE_VARIANT_ID; })[0] || null;
  }

  // Theme neu rendern lassen (Trigger = theme:cartchanged, wie addedToCartHandler)
  function refreshDrawer(openDrawer) {
    document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {
      bubbles: true, cancelable: false, detail: { openDrawer: !!openDrawer }
    }));
  }

  // ---- Sample-Set Auto-Add / Auto-Remove --------------------
  var scBusy = false;
  function reconcileSample(cart) {
    if (scBusy) return Promise.resolve(false);
    var q = qualifyingTotal(cart);
    var line = sampleLine(cart);
    // hinzufügen
    if (q >= CFG.TIER2 && !line) {
      scBusy = true;
      var add = window.SmCart && SmCart.addToCart
        ? SmCart.addToCart([{ id: CFG.SAMPLE_VARIANT_ID, quantity: 1 }])
        : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: CFG.SAMPLE_VARIANT_ID, quantity: 1 }] }) });
      return add.then(function () { scBusy = false; refreshDrawer(false); return true; })
        .catch(function (e) { scBusy = false; console.warn('[SmSlideCart] sample add failed', e); return false; });
    }
    // entfernen
    if (q < CFG.TIER2 && line) {
      scBusy = true;
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0 })
      }).then(function () { scBusy = false; refreshDrawer(false); return true; })
        .catch(function (e) { scBusy = false; console.warn('[SmSlideCart] sample remove failed', e); return false; });
    }
    return Promise.resolve(false);
  }

  // ---- Widget-DOM aufbauen / aktualisieren ------------------
  function ensureWidget() {
    var upper = document.querySelector('.cart-drawer .cart-drawer__content-upper');
    if (!upper) return null;
    var w = upper.querySelector('.sm-sc');
    if (!w) {
      w = document.createElement('div');
      w.className = 'sm-sc';
      w.innerHTML =
        '<div class="sm-sc-timer"></div>' +
        '<div class="sm-sc-reward">' +
          '<p class="sm-sc-reward__msg"></p>' +
          '<div class="sm-sc-track">' +
            '<div class="sm-sc-track__fill"></div>' +
            '<div class="sm-sc-node sm-sc-node--t1">' + SVG_CHECK + '</div>' +
            '<div class="sm-sc-node sm-sc-node--t2">' + SVG_CHECK + '</div>' +
            '<div class="sm-sc-track__truck">' + SVG_TRUCK + '</div>' +
          '</div>' +
          '<div class="sm-sc-labels">' +
            '<div class="sm-sc-label sm-sc-label--t1"><b>' + money(CFG.TIER1) + '</b>' + T.ship_free + '</div>' +
            '<div class="sm-sc-label sm-sc-label--t2"><b>' + money(CFG.TIER2) + '</b>' + T.sample_free + '</div>' +
          '</div>' +
        '</div>';
      // Nach dem Header einfügen (Reihenfolge: Header → Timer → Reward → Items),
      // damit Titel + Schließen-X oben bleiben (wie in der AMP-Version).
      var header = upper.querySelector('.cart-drawer__header');
      if (header && header.nextSibling) upper.insertBefore(w, header.nextSibling);
      else if (header) upper.appendChild(w);
      else upper.insertBefore(w, upper.firstChild);
    }
    return w;
  }

  function renderReward(cart) {
    var w = ensureWidget();
    if (!w) return;
    var q = qualifyingTotal(cart);
    var t1 = q >= CFG.TIER1, t2 = q >= CFG.TIER2;

    // Fortschritt (0 → TIER2), Truck sitzt bei aktueller Position
    var pct = Math.max(0, Math.min(1, q / CFG.TIER2));
    var fill = w.querySelector('.sm-sc-track__fill');
    var truck = w.querySelector('.sm-sc-track__truck');
    if (fill) fill.style.transform = 'scaleX(' + pct + ')'; // GPU-transform statt width (kein Layout-Thrash)
    if (truck) truck.style.left = (pct * 100) + '%';

    // Node-Positionen (T1 relativ auf der 0→TIER2-Skala)
    var n1 = w.querySelector('.sm-sc-node--t1'), n2 = w.querySelector('.sm-sc-node--t2');
    var l1 = w.querySelector('.sm-sc-label--t1'), l2 = w.querySelector('.sm-sc-label--t2');
    if (n1) { n1.style.left = ((CFG.TIER1 / CFG.TIER2) * 100) + '%'; n1.classList.toggle('sm-sc-node--done', t1); }
    if (n2) { n2.style.left = '100%'; n2.classList.toggle('sm-sc-node--done', t2); }
    if (l1) { l1.style.left = ((CFG.TIER1 / CFG.TIER2) * 100) + '%'; l1.classList.toggle('sm-sc-label--done', t1); }
    if (l2) { l2.style.left = '100%'; l2.classList.toggle('sm-sc-label--done', t2); }

    // Botschaft
    var msg = w.querySelector('.sm-sc-reward__msg');
    var reward = w.querySelector('.sm-sc-reward');
    if (msg) {
      if (t2) { msg.innerHTML = T.all_done; }
      else if (t1) { msg.innerHTML = T.to_sample(money(CFG.TIER2 - q)); }
      else { msg.innerHTML = T.to_ship(money(CFG.TIER1 - q)); }
    }
    if (reward) reward.classList.toggle('sm-sc-reward--done', t2);
  }

  // ---- Rabattcode-Feld --------------------------------------
  function ensureDiscount() {
    var footer = document.querySelector('.cart-drawer .cart-drawer__footer');
    if (!footer || footer.querySelector('.sm-sc-disc-wrap')) return;
    var wrap = document.createElement('div');
    wrap.className = 'sm-sc-disc-wrap';
    wrap.innerHTML =
      '<div class="sm-sc-disc">' +
        '<input type="text" class="sm-sc-disc__input" placeholder="' + T.disc_ph + '" autocomplete="off" autocapitalize="characters" spellcheck="false">' +
        '<button type="button" class="sm-sc-disc__btn">' + T.disc_apply + '</button>' +
      '</div>' +
      '<p class="sm-sc-disc__msg" hidden></p>';
    footer.insertBefore(wrap, footer.firstChild);
  }
  function hasCode(cart, code) {
    var lc = code.toLowerCase();
    return (cart.cart_level_discount_applications || []).some(function (d) {
      return (d.title || '').toLowerCase() === lc;
    });
  }
  function discMsg(wrap, kind, text) {
    var m = wrap.querySelector('.sm-sc-disc__msg');
    if (!m) return;
    m.className = 'sm-sc-disc__msg sm-sc-disc__msg--' + kind;
    m.textContent = text;
    m.hidden = false;
  }
  function applyDiscount(code, wrap, btn) {
    btn.disabled = true;
    var before = 0;
    getCart().then(function (c0) {
      before = c0.total_discount || 0;
      // /discount/{code} setzt den Session-Rabatt; redirect=/cart.js spart das HTML.
      return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' });
    }).then(function () {
      return getCart();
    }).then(function (c1) {
      var applied = (c1.total_discount || 0) > before || hasCode(c1, code);
      discMsg(wrap, applied ? 'ok' : 'err', applied ? T.disc_ok : T.disc_err);
      btn.disabled = false;
      if (applied) refreshDrawer(false); // Theme zeigt Rabatt-Zeile + neue Summe
    }).catch(function () {
      discMsg(wrap, 'err', T.disc_err);
      btn.disabled = false;
    });
  }

  // ---- Rabattcode ENTFERNEN ---------------------------------
  // Nur per Code angewendete Rabatte sind entfernbar (cart.discount_codes).
  // Automatische Rabatte (nur in cart_level_discount_applications, ohne Code)
  // kann der Kunde NICHT entfernen -> bekommen kein ×.
  var discBusy = false;
  function appliedCodes(cart) {
    return (cart.discount_codes || [])
      .map(function (d) { return d && d.code ? d.code : null; })
      .filter(Boolean);
  }
  function removeDiscount(codeToRemove) {
    if (discBusy) return;
    discBusy = true;
    // Frischen Cart holen (Codes könnten sich seit dem Rendern geändert haben)
    // und die verbleibenden Codes als kommaseparierte Liste zurückschreiben.
    getCart().then(function (cart) {
      var remaining = appliedCodes(cart).filter(function (c) {
        return c.toLowerCase() !== codeToRemove.toLowerCase();
      });
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: remaining.join(',') })
      });
    }).then(function () {
      discBusy = false;
      refreshDrawer(false); // Theme rendert Footer neu -> Rabattzeile verschwindet
    }).catch(function (e) {
      discBusy = false;
      console.warn('[SmSlideCart] discount remove failed', e);
    });
  }
  // Hängt ein × an jede native Rabattzeile, deren Titel einem angewendeten
  // Code entspricht. Läuft nach jedem cartchanged erneut (Footer wird neu
  // gemerged) -> idempotent per Klassen-Guard.
  function enhanceDiscountRemoval(cart) {
    var codes = appliedCodes(cart);
    var lis = document.querySelectorAll('.cart-drawer .cart-discount');
    [].forEach.call(lis, function (li) {
      if (li.querySelector('.sm-sc-disc-remove')) return;
      var titleEl = li.querySelector('.cart-discount__title');
      var title = titleEl ? (titleEl.textContent || '').trim() : '';
      if (!title) return;
      var match = codes.filter(function (c) { return c.toLowerCase() === title.toLowerCase(); })[0];
      if (!match) return; // automatischer Rabatt -> nicht entfernbar
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sm-sc-disc-remove';
      btn.setAttribute('aria-label', (IS_EN ? 'Remove discount code ' : 'Rabattcode entfernen: ') + match);
      btn.setAttribute('title', (IS_EN ? 'Remove' : 'Entfernen'));
      btn.innerHTML = SVG_X;
      btn.addEventListener('click', function () { removeDiscount(match); });
      li.appendChild(btn);
    });
  }

  // ---- Haupt-Refresh nach jeder Cart-Änderung ---------------
  var reconciling = false;
  function drawerItemCount() {
    // Anzahl gerenderter Cart-Positionen im nativen Drawer-Body
    return document.querySelectorAll('.cart-drawer .cart-item-list__body [data-merge-list-item]').length;
  }
  // ---- Abo pro Position: Dropdown (Einmalig / alle 4-6-8 Wochen) neben dem Mengen-Stepper ----
  var subCache = {};
  function weeksFromName(n) { var m = (n || '').match(/(\d+)/); return m ? m[1] : ''; }
  function getSub(handle) {
    if (subCache[handle]) return Promise.resolve(subCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (pj) {
        var g = (pj.selling_plan_groups || [])[0];
        var planMap = {}; // selling_plan_id -> weeks
        ((g && g.selling_plans) || []).forEach(function (sp) { planMap[sp.id] = weeksFromName(sp.name); });
        // Pläne PRO VARIANTE (5-ml-Sample-Varianten haben keine Allocations -> kein Abo)
        var byVariant = {};
        (pj.variants || []).forEach(function (v) {
          var plans = (v.selling_plan_allocations || []).map(function (a) {
            return { id: a.selling_plan_id, weeks: planMap[a.selling_plan_id] || '' };
          });
          plans.sort(function (a, b) { return (+a.weeks) - (+b.weeks); });
          byVariant[v.id] = plans;
        });
        var info = { byVariant: byVariant };
        subCache[handle] = info; return info;
      }).catch(function () { var info = { byVariant: {} }; subCache[handle] = info; return info; });
  }
  var subBusy = false;
  function switchSub(key, sellingPlan, qty) {
    if (subBusy) return; subBusy = true;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty || 1, selling_plan: sellingPlan || null }) })
      .then(function () { subBusy = false; refreshDrawer(false); })
      .catch(function () { subBusy = false; });
  }
  function enhanceSubs(cart) {
    var items = cart.items || [];
    var nodes = [].slice.call(document.querySelectorAll('.cart-drawer .cart-item-list__body [data-merge-list-item]'));
    items.forEach(function (it, idx) {
      if (it.variant_id === CFG.SAMPLE_VARIANT_ID) return; // kein Abo fürs Gratis-Sample
      var node = null;
      nodes.forEach(function (n) { var a = n.getAttribute('data-merge-list-item') || ''; if (a.indexOf('item-key:' + it.key) === 0) node = n; });
      if (!node) node = nodes[idx];
      if (!node) return;
      var qcol = node.querySelector('.cart-item__quantity');
      if (!qcol || qcol.querySelector('.sm-sc-subsel')) return;
      getSub(it.handle).then(function (info) {
        var plans = info.byVariant[it.variant_id] || [];
        if (!plans.length || qcol.querySelector('.sm-sc-subsel')) return; // Variante ohne Abo (z.B. 5 ml) -> kein Dropdown
        var current = it.selling_plan_allocation ? String(it.selling_plan_allocation.selling_plan.id) : '';
        var html = '<option value="">' + T.sub_once + '</option>';
        plans.forEach(function (pl) {
          html += '<option value="' + pl.id + '"' + (String(pl.id) === current ? ' selected' : '') + '>' + T.sub_every + ' ' + pl.weeks + ' ' + T.sub_weeks + ' · ' + T.sub_off + '</option>';
        });
        var sel = document.createElement('select');
        sel.className = 'sm-sc-subsel' + (current ? ' is-abo' : '');
        sel.setAttribute('aria-label', T.sub_abo);
        sel.innerHTML = html;
        qcol.appendChild(sel);
        sel.addEventListener('change', function () { switchSub(it.key, sel.value, it.quantity); });
        // Konkreter Sparbetrag: Peach-Nudge bei Einmalig, grüne Bestätigung bei Abo
        var hint = document.createElement('span');
        if (current) {
          var orig = Math.round(it.final_line_price / 0.8);
          hint.className = 'sm-sc-save sm-sc-save--on';
          hint.innerHTML = '<span class="sm-sc-save-pill">' + T.sub_off + '</span> ' + T.sub_hint_on + ' ' + money(orig - it.final_line_price);
        } else {
          hint.className = 'sm-sc-save sm-sc-save--hint';
          hint.innerHTML = '<span class="sm-sc-save-pill">' + T.sub_off + '</span> ' + T.sub_hint_once + ' ' + money(Math.round(it.final_line_price * 0.2));
        }
        qcol.appendChild(hint);
      });
    });
  }
  function onCartChanged() {
    getCart().then(function (cart) {
      renderReward(cart);
      enhanceSubs(cart);
      enhanceDiscountRemoval(cart);
      // Stale-Schutz: wenn der Theme-Body eine andere Positions-Anzahl zeigt
      // als der echte Cart (z.B. Änderung in anderem Tab), Body neu holen.
      if (!reconciling && !scBusy) {
        var domN = drawerItemCount();
        var realN = (cart.items || []).length;
        if (domN > 0 && domN !== realN) { refreshDrawer(false); return; }
      }
      if (reconciling) return;
      reconciling = true;
      reconcileSample(cart).then(function (changed) {
        reconciling = false;
        // Nach Add/Remove rendert das Theme neu → onCartChanged läuft erneut,
        // renderReward wird dann mit frischem Cart aufgerufen.
      });
    });
  }

  // ---- SLIDECART_*-Shim (nur wenn AMP fehlt) ----------------
  function installShim() {
    if (typeof window.SLIDECART_OPEN !== 'function') {
      window.SLIDECART_OPEN = function () {
        document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: true } }));
        document.dispatchEvent(new CustomEvent('theme:open-cart-drawer', { bubbles: true, cancelable: false }));
      };
    }
    if (typeof window.SLIDECART_CLOSE !== 'function') {
      window.SLIDECART_CLOSE = function () {
        document.dispatchEvent(new CustomEvent('theme:close-cart-drawer', { bubbles: true, cancelable: false }));
      };
    }
    if (typeof window.SLIDECART_UPDATE !== 'function') {
      window.SLIDECART_UPDATE = function () { refreshDrawer(false); };
    }
    if (typeof window.SLIDECART_SET_CART !== 'function') {
      window.SLIDECART_SET_CART = function () { refreshDrawer(false); };
    }
    if (typeof window.SLIDECART_STATE !== 'function') {
      window.SLIDECART_STATE = function () {
        var m = document.querySelector('.cart-drawer-modal');
        return { isOpen: !!(m && m.getAttribute('aria-hidden') === 'false') };
      };
    }
    if (typeof window.SLIDECART_APPLY_DISCOUNT !== 'function') {
      window.SLIDECART_APPLY_DISCOUNT = function (code) {
        if (!code) return;
        // Best-effort: Discount-URL setzt den Code für den Checkout
        return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
          .then(function () { refreshDrawer(false); });
      };
    }
  }

  // ---- Init -------------------------------------------------
  function init() {
    installShim();
    // Drawer öffnen → Timer reset + Reward rendern
    document.addEventListener('theme:open-cart-drawer', function () {
      resetTimer();
      ensureWidget();
      ensureDiscount();
      onCartChanged();
    });
    // Cart geändert → Reward neu + Timer reset (Aktivität) + Reconcile
    // Listener auf document: fängt sowohl auf document als auch auf
    // documentElement (bubbles) gefeuerte theme:cartchanged-Events.
    document.addEventListener('theme:cartchanged', function () {
      // kleiner Delay, damit das Theme sein Section-Merge abgeschlossen hat
      setTimeout(function () { ensureWidget(); ensureDiscount(); resetTimer(); onCartChanged(); }, 60);
    });
    // Rabattcode anwenden (Klick + Enter, delegiert)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.sm-sc-disc__btn');
      if (!btn) return;
      var wrap = btn.closest('.sm-sc-disc-wrap');
      var input = wrap && wrap.querySelector('.sm-sc-disc__input');
      var code = input && (input.value || '').trim();
      if (code) applyDiscount(code, wrap, btn);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target.closest && e.target.closest('.sm-sc-disc__input');
      if (!input) return;
      e.preventDefault();
      var wrap = input.closest('.sm-sc-disc-wrap');
      var btn = wrap && wrap.querySelector('.sm-sc-disc__btn');
      var code = (input.value || '').trim();
      if (code && btn) applyDiscount(code, wrap, btn);
    });
    // Falls Drawer schon im DOM (Sofort-Render)
    if (document.querySelector('.cart-drawer__content-upper')) {
      ensureWidget();
      ensureDiscount();
      onCartChanged();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
